import { useEffect, useState } from 'react';
import { connect, RootStateOrAny } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';

import { Skeleton } from 'antd';

import notifier from 'utils/notifier';
import { ErrorResponse } from 'utils/types';

import { getTestHistory, getAllTestHistory } from 'store/claim/batchReports/actions';
import { getFileTypes } from 'store/parameter/actions';

import BatchClaimUpload from 'components/Claims/BatchClaims/BatchClaimUpload';
import BatchClaimTestFileListModal from 'components/Claims/BatchClaims/Modals';
import BatchClaimTestUpload from 'components/Claims/BatchClaims/BatchClaimTestUpload';

// NOTE: Will not work properly without AntiVirusHost Server running in conjunction with backend as of 09/27/21

interface SubmitBatchClaimsPageProps {
  getTestHistory(userId: string): any,
  isFetchingTestHistory: boolean,
  getAllTestHistory(userId: string): any,
  isFetchingAllTestHistory: boolean,
  getFileTypes(parameter: any): any,
  isFetchingFileTypes: boolean,
};

const SubmitBatchClaimsPage = (props: SubmitBatchClaimsPageProps) => {

  const [page, setPage] = useState('test');
  const [fileTypes, setFileTypes] = useState('');
  const [testFiles, setTestFiles] = useState<any[]>([]);
  const [modalVisible, setModalVisible] = useState(false);
  const [registered, setRegistered] = useState(false); // for Batch Claim Upload

  useEffect(() => {
    getFileTypes();
    getTestHistory();
    getAllTestHistory();
  }, []);

  useEffect(() => {
    if (page === 'test' && testFiles?.length > 0) setModalVisible(true);
  }, [page]);

  const isModalVisibleHandler = () => {
    setModalVisible(false);
  };

  const getTestHistory = () => {
    return props.getTestHistory(sessionStorage.getItem('user_id')!)
      .then((response: any[]) => {
        setTestFiles(response);
      })
      .catch((err: ErrorResponse) => {
        setPage("files");
        console.error(err?.response?.data?.Message || 'Something went wrong, please contact a system administrator.');
      });
  };

  const getAllTestHistory = () => {
    return props.getAllTestHistory(sessionStorage.getItem('user_id')!)
      .then((response: any[]) => {
        if (response?.some(e => e.RmiApproved === 'Y')) {
          setPage('files');
          setRegistered(true); // for Batch Claim Upload
        }
      })
      .catch((err: ErrorResponse) => {
        setPage("files");
        console.error(err?.response?.data?.Message || 'Something went wrong, please contact a system administrator.');
      });
  };

  const getFileTypes = () => {
    return props.getFileTypes('BatchClaimExtension')
      .then((response: any[]) => {
        setFileTypes(response[0]?.RmiPvalue)
      })
      .catch((err: ErrorResponse) => {
        console.error(err?.response?.data?.Message || 'Something went wrong, please contact a system administrator.');
      });
  };

  return (
    props.isFetchingTestHistory || props.isFetchingFileTypes ? (
      <>
        <Skeleton
          avatar
          active
          paragraph={{ rows: 4 }}
        />
        <br />
        <Skeleton
          active
          paragraph={{ rows: 4 }}
        />
      </>
    ) : (
      <>
        {page === 'test' ? 
          <BatchClaimTestUpload 
            fileTypes={fileTypes}
            page={page}
            setPage={setPage}
            registered={registered}
          />
          :
          <BatchClaimUpload 
            fileTypes={fileTypes} 
            page={page} 
            setPage={setPage} 
          />
        }
        <BatchClaimTestFileListModal 
          testFiles={testFiles}
          visible={modalVisible}
          isModalVisibleHandler={isModalVisibleHandler}
          title={'Outstanding Claim Submission Test Files'}
          width={750}
          setVisible={setModalVisible}
          footer={[]}
        />
      </>
    )
  );
};

const mapStateToProps = (store: RootStateOrAny) => ({
  isFetchingTestHistory: store.rootReducer.claimBatchReports.isFetchingHistory,
  isFetchingAllTestHistory: store.rootReducer.claimBatchReports.isFetchingAllHistory,
  isFetchingFileTypes: store.rootReducer.parameter.isFetchingFileTypes,
});

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators(
{
  getTestHistory,
  getAllTestHistory,
  getFileTypes,
},
  dispatch,
);

export default connect(mapStateToProps, mapDispatchToProps)(SubmitBatchClaimsPage);
